module.exports = __webpack_public_path__ + "static/media/rapunzel.f89b1047.png";